import React from 'react';
import {connect} from "react-redux";
import moment from 'moment';
import ScopeApi from "../../apis/ScopeApi";
import {setFullScope} from "../../actions/scopeAction";

class ScopeFull extends React.Component {

    componentDidMount() {
        const {scope, setFullScope} = this.props;
        if(!scope.full || (scope.fullLastLoaded && moment(scope.fullLastLoaded).isBefore(moment().subtract(2, 'hour')))) {
            ScopeApi.loadFullScope()
                .then((response) => {
                    if(response.data && response.data.success) {
                        setFullScope(response.data.data);
                    }
                });
        }
    }

    render() {
        return null;
    }
}

const mapStateToProps = state => ({
    scope: state.scope
});

export default connect(mapStateToProps, {
    setFullScope
})(ScopeFull);
